module.exports = __webpack_public_path__ + "teqbahn-assets/media/3.59a61c98.jpg";